import { router } from "@inertiajs/react";
import { useCallback } from "react";
import type { BizminerPeerData } from "@/types/serializers";
import { save_peer_selection_bizminer_app_pillar_insight_path } from "@/routes";
import { MAX_PEERS } from "./scoring-constants";

interface UseScoringPeersParams {
  peerData: BizminerPeerData;
  pillarInsightId: number;
}

export function useScoringPeers({
  peerData,
  pillarInsightId,
}: UseScoringPeersParams) {
  const { peer_pool, selected_peer_ids, peer_columns, peer_names, categories_with_peers } =
    peerData;

  const savePeers = useCallback(
    (newPeerIds: string[]) => {
      router.patch(
        save_peer_selection_bizminer_app_pillar_insight_path(pillarInsightId),
        { peer_account_ids: newPeerIds },
        { preserveState: true, preserveScroll: true },
      );
    },
    [pillarInsightId],
  );

  const addPeer = useCallback(
    (peerId: string) => {
      if (selected_peer_ids.length < MAX_PEERS) {
        savePeers([...selected_peer_ids, peerId]);
      }
    },
    [selected_peer_ids, savePeers],
  );

  const removePeer = useCallback(
    (peerId: string) => {
      savePeers(selected_peer_ids.filter((id) => id !== peerId));
    },
    [selected_peer_ids, savePeers],
  );

  return {
    peer_pool,
    selected_peer_ids,
    peer_columns,
    peer_names,
    categories_with_peers,
    addPeer,
    removePeer,
  };
}
